import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=4236a7ae&scoped=true&"
import script from "./AppForm.vue?vue&type=script&lang=js&"
export * from "./AppForm.vue?vue&type=script&lang=js&"
import style0 from "./AppForm.vue?vue&type=style&index=0&id=4236a7ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4236a7ae",
  null
  
)

export default component.exports